import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

const SERVER_URL = "https://allinone-clone-7d5d795e98ce.herokuapp.com";

const Footer = () => {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${SERVER_URL}/api/footer`);
        if (res.data.success) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("Failed to load footer:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return null;
  if (!data || !data.isActive) return null;

  return (
    <>
     <footer className="position-relative overflow-hidden mt-auto" style={{ backgroundColor: "#030305" }}>
        
        {/* Sleek Edge-Lit Top Border */}
        <div className="position-absolute top-0 start-0 w-100" style={{ height: "1px", background: "linear-gradient(90deg, transparent 0%, rgba(99, 102, 241, 0.5) 50%, transparent 100%)" }}></div>
        
        {/* Subtle Tech Grid Background */}
        <div className="position-absolute w-100 h-100 top-0 start-0 z-0 pointer-events-none opacity-25" style={{ backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)", backgroundSize: "60px 60px", maskImage: "linear-gradient(to bottom, black 0%, transparent 100%)", WebkitMaskImage: "linear-gradient(to bottom, black 0%, transparent 100%)" }}></div>

        <div className="container position-relative z-1 pt-5 pb-4">
          <div className="row justify-content-between mt-4">
            
            {/* Column 1: About & Social */}
            <div className="col-xl-4 col-lg-5 col-md-6 mb-5 mb-lg-0 pe-lg-5">
              <div className="mb-4">
                <Link to="/" className="d-inline-block position-relative">
                  {/* Subtle logo glow */}
                  <div className="position-absolute top-50 start-50 translate-middle bg-primary rounded-circle blur-glow z-n1" style={{ width: "80px", height: "40px", opacity: "0.2" }}></div>
                  <img src={data.logo} alt="logo" style={{ maxHeight: "40px", position: "relative", zIndex: "1" }} />
                </Link>
              </div>
              <p className="text-secondary mb-4" style={{ lineHeight: "1.7", fontSize: "0.95rem" }}>{data.aboutText}</p>
              
              <div className="d-flex align-items-center gap-3">
                {data.socialLinks?.map((social) => (
                  <a key={social.id} href={social.url} target="_blank" rel="noopener noreferrer" className="social-btn d-flex align-items-center justify-content-center rounded-circle text-white text-decoration-none">
                    <i className={social.icon} />
                  </a>
                ))}
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="col-xl-2 col-lg-3 col-md-6 mb-5 mb-lg-0">
              <h5 className="text-white fw-bold mb-4" style={{ letterSpacing: "0.05em" }}>{data.quickLinks?.title || "Product"}</h5>
              <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                {data.quickLinks?.links?.map((link) => (
                  <li key={link.id}>
                    <Link to={link.url} className="footer-link text-secondary text-decoration-none d-inline-block">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Contact Info */}
            <div className="col-xl-3 col-lg-4 col-md-12">
              <h5 className="text-white fw-bold mb-4" style={{ letterSpacing: "0.05em" }}>{data.contactInfo?.title || "Contact"}</h5>
              
              <div className="d-flex flex-column gap-4">
                {/* Emails */}
                {data.contactInfo?.emails?.length > 0 && (
                  <div className="d-flex align-items-start">
                    <div className="contact-icon-wrapper d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0">
                      <i className="fa-regular fa-envelope text-primary" />
                    </div>
                    <div>
                      {data.contactInfo.emails.map((email, index) => (
                        <div key={index} className="mb-1">
                          <a href={`mailto:${email}`} className="footer-link text-secondary text-decoration-none">{email}</a>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Phones */}
                {data.contactInfo?.phones?.length > 0 && (
                  <div className="d-flex align-items-start">
                    <div className="contact-icon-wrapper d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0">
                      <i className="fa-solid fa-phone text-primary" />
                    </div>
                    <div>
                      {data.contactInfo.phones.map((phone, index) => (
                        <div key={index} className="mb-1">
                          <a href={`tel:${phone.replace(/\s/g, '')}`} className="footer-link text-secondary text-decoration-none">{phone}</a>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="position-relative z-1 mt-3" style={{ borderTop: "1px solid rgba(255,255,255,0.05)" }}>
          <div className="container py-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
              <p className="text-muted mb-0 small" dangerouslySetInnerHTML={{ __html: data.copyrightText }} />
             
            </div>
          </div>
        </div>

        <style jsx>{`
          .blur-glow {
            filter: blur(20px);
          }

          .social-btn {
            width: 40px;
            height: 40px;
            background: rgba(255, 255, 255, 0.03);
            border: 1px solid rgba(255, 255, 255, 0.08);
            transition: all 0.3s ease;
          }
          .social-btn:hover {
            background: rgba(99, 102, 241, 0.15);
            border-color: rgba(99, 102, 241, 0.4);
            transform: translateY(-3px);
            color: #818cf8 !important;
            box-shadow: 0 5px 15px rgba(99, 102, 241, 0.2);
          }

          .footer-link {
            transition: all 0.3s ease;
            position: relative;
          }
          .footer-link:hover {
            color: #818cf8 !important;
            transform: translateX(4px);
          }

          .contact-icon-wrapper {
            width: 42px;
            height: 42px;
            background: rgba(99, 102, 241, 0.08);
            border: 1px solid rgba(99, 102, 241, 0.15);
            transition: all 0.3s ease;
          }
          .d-flex.align-items-start:hover .contact-icon-wrapper {
            background: rgba(99, 102, 241, 0.2);
            border-color: rgba(99, 102, 241, 0.4);
            box-shadow: 0 0 15px rgba(99, 102, 241, 0.2);
          }
        `}</style>
      </footer>
    </>
  );
};

export default Footer;